import { render, staticRenderFns } from "./PageListNew.vue?vue&type=template&id=0aff4370&"
import script from "./PageListNew.vue?vue&type=script&lang=js&"
export * from "./PageListNew.vue?vue&type=script&lang=js&"
import style0 from "./PageListNew.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports